// client/components/system/MarkdownContent.jsx
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeSanitize from "rehype-sanitize";
import { useTheme } from "../../context/ThemeContext.jsx";
const components = isDark => ({
  h1: ({
    children
  }) => <h1 className={`text-xl font-bold mt-6 mb-2 ${"text-white"}`}>{children}</h1>,
  h2: ({
    children
  }) => <h2 className={`text-lg font-semibold mt-5 mb-2 ${"text-white"}`}>{children}</h2>,
  h3: ({
    children
  }) => <h3 className={`text-base font-semibold mt-4 mb-1.5 ${"text-white/90"}`}>{children}</h3>,
  p: ({
    children
  }) => <p className={`text-sm leading-relaxed mb-3 ${"text-white/60"}`}>{children}</p>,
  ul: ({
    children
  }) => <ul className={`list-disc list-inside space-y-1 text-sm mb-3 ${"text-white/60"}`}>{children}</ul>,
  ol: ({
    children
  }) => <ol className={`list-decimal list-inside space-y-1 text-sm mb-3 ${"text-white/60"}`}>{children}</ol>,
  li: ({
    children
  }) => <li className="leading-relaxed">{children}</li>,
  strong: ({
    children
  }) => <strong className={`font-semibold ${"text-white/80"}`}>{children}</strong>,
  em: ({
    children
  }) => <em className="italic">{children}</em>,
  code: ({
    children,
    inline
  }) => inline ? <code className={`px-1.5 py-0.5 rounded text-xs font-mono ${"bg-white/10 text-blue-300"}`}>{children}</code> : <pre className={`p-3 rounded-lg text-xs font-mono overflow-x-auto mb-3 ${"bg-white/5 text-white/70"}`}><code>{children}</code></pre>,
  blockquote: ({
    children
  }) => <blockquote className={`border-l-3 pl-4 my-3 ${"border-blue-400/30 text-white/50"}`}>
      {children}
    </blockquote>,
  hr: () => <hr className={`my-4 ${"border-white/10"}`} />,
  a: ({
    href,
    children
  }) => <a href={href} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-400 underline underline-offset-2">{children}</a>,
  table: ({
    children
  }) => <div className="overflow-x-auto mb-3"><table className={`text-sm w-full ${"text-white/60"}`}>{children}</table></div>,
  th: ({
    children
  }) => <th className={`text-left px-3 py-1.5 text-xs font-semibold border-b ${"border-white/10 text-white/70"}`}>{children}</th>,
  td: ({
    children
  }) => <td className={`px-3 py-1.5 border-b ${"border-white/5"}`}>{children}</td>
});
export default function MarkdownContent({
  children
}) {
    const { isDark } = useTheme();
  if (!children) return null;
  return <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeSanitize]} components={components(isDark)}>
      {children}
    </ReactMarkdown>;
}